import { MetaT } from '@global/types';

export default {
    title: 'Юридическая информация о платформе CRM LIVECARGO для работы с самозанятыми',
    description:
        'Пользовательское соглашение, политика обработки и защиты персональных данных, IT-аккредитация, описание программного обеспечения и электронная подпись CRM LIVECARGO',
} as MetaT;
